<template>
  <div class="job-item-wrapper">
    <router-link :to="job.route" class="route-item">
      <div :class="isMobile ? statusList : ''" class="status">
        <div v-if="!isMobile" :class="statusList" class="bullet"></div>
        <p>{{ statusText }}</p>
      </div>
      <p v-if="!isMobile">
        {{ `${job.appointmentNo}/${job.quantity}` }}
      </p>
      <p class="title truncate two-lines">{{ job.service.name }}</p>
      <p v-if="isMobile" class="quantity">
        {{ `ครั้งที่ ${job.appointmentNo}/${job.quantity}` }}
      </p>
      <div class="user mt-2">
        <div class="item">
          <img :src="'/static/icons/supplier-icon/user-icon.svg'" />
          <p class="truncate one-line">{{ job.home.contact.name }}</p>
        </div>
        <div class="item">
          <img :src="'/static/icons/supplier-icon/tel-icon.svg'" />
          <p>{{ job.home.contact.phoneNumber }}</p>
        </div>
      </div>
      <div class="appointment">
        <div class="item">
          <img :src="'/static/icons/supplier-icon/appointment-icon.svg'" />
          <p :class="appointmentTimeClassList">
            {{ `${dateText} ${timeText}` }}
          </p>
        </div>
        <div class="item">
          <img :src="'/static/icons/supplier-icon/address-icon.svg'" />
          <p class="truncate two-lines">{{ job.home.address }}</p>
        </div>
      </div>
      <div class="note">
        <p v-if="isMobile" class="title">{{ "หมายเหตุ" }}</p>
        <p class="truncate two-lines">{{ job.note }}</p>
      </div>
    </router-link>
  </div>
</template>

<script>
import {
  toLocaleTH,
  getDurationAppointmentTimeText,
  getAppointmentTimeText,
} from "@/lib/dateTime"
import { DateTime } from "luxon"
import { mSize } from "../StaticVariable"

export default {
  props: {
    job: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      type: this.$route.params.type,
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth < mSize
    },
    dateTimeTH() {
      if (!this.job.dateTime) return null
      return toLocaleTH(DateTime.fromISO(this.job.dateTime))
    },
    dateText() {
      return this.dateTimeTH.toFormat("dd MMM yyyy")
    },
    timeText() {
      const appointmentDurationTime = getDurationAppointmentTimeText(
        this.job.dateTime || null,
        this.job.dateTimeEnd || null,
      )
      if (appointmentDurationTime) return appointmentDurationTime

      return getAppointmentTimeText(this.job.dateTime)
    },
    statusText() {
      const statusMap = {
        CREATED: "รอยืนยัน",
        CONFIRMED: "ยืนยันแล้ว",
        WAIT_CONFIRMED_SERVICE_COMPLETE: "รอดำเนินการ",
        PROVIDER_FULFILLED: "ปิดงานแล้ว",
      }

      return statusMap[this.job.status]
    },
    appointmentTimeClassList() {
      return [`time_${this.job.status.toLowerCase()}`]
    },
    statusList() {
      return [this.job.status.toLowerCase()]
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
@import "~@/lib/scss/variables";
.job-item-wrapper {
  display: flex;
  flex-direction: column;

  > .route-item {
    display: grid;
    width: max-content;
    grid-template-columns: 130px 100px 250px 170px 280px 220px;
    grid-gap: 16px;
    align-items: center;
    padding: 12px 24px;
    border-bottom: 1px solid rgba(201, 201, 201, 0.3);
    color: $black;

    &:hover {
      color: inherit;
      text-decoration: none;
      background: #fafafa;
    }

    > .status {
      display: flex;
      flex-direction: row;
      align-items: center;
      grid-gap: 12px;

      > .bullet {
        width: 16px;
        height: 16px;
        border-radius: 50%;
      }
    }

    > .quantity {
      margin-top: -8px;
    }

    > .user {
      display: flex;
      flex-direction: column;
      grid-gap: 4px;

      > .item {
        display: flex;
        flex-direction: row;
        align-items: center;
        grid-gap: 12px;
      }
    }

    > .appointment {
      display: flex;
      flex-direction: column;
      grid-gap: 4px;

      > .item {
        display: flex;
        flex-direction: row;
        align-items: center;
        grid-gap: 12px;
      }
    }

    > .note {
      display: flex;
      flex-direction: column;

      > .item {
        display: flex;
        flex-direction: row;
        align-items: center;
        grid-gap: 12px;
      }
    }

    > .note {
      display: flex;
      flex-direction: column;

      > .item {
        display: flex;
        flex-direction: row;
        align-items: center;
        grid-gap: 12px;
      }
    }
  }
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.one-line {
  -webkit-line-clamp: 1;
}

.two-lines {
  -webkit-line-clamp: 2;
}

.title {
  font-weight: bold;
}

p {
  font-size: $font-16;
  color: $black;
}

img {
  width: 20px;
}

.time_created,
.time_confirmed,
.time_wait_confirmed_service_complete {
  color: $primary-color;
}

.created {
  background-color: $secondary-color;
}

.cancelled {
  background-color: $danger-color;
}

.confirmed,
.wait_confirmed_service_complete {
  background-color: $warning-color;
}

.provider_fulfilled {
  background-color: $success-dark-color;
}

.fulfilled {
  background-color: $success-color;
}

@media (max-width: ($m-size - 1)) {
  .job-item-wrapper {
    display: flex;
    flex-direction: column;
    padding: 0 24px;

    > .route-item {
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: start;
      grid-gap: 8px;
      padding: 16px;
      border-top: 8px solid $supplier-primary-color;
      border-left: 1px solid #e6e6e6;
      border-right: 1px solid #e6e6e6;
      border-bottom: 1px solid #e6e6e6;
      border-radius: 8px;

      > .status {
        padding: 0 16px;
        border-radius: 8px;

        p {
          font-size: $font-14;
          color: $white;
        }
      }

      > .user {
        width: 100%;
      }

      > .appointment {
        width: 100%;
      }

      > .note {
        width: 100%;
        background-color: #f6f6f6;
        border-radius: 8px;
        padding: 8px 16px;

        p {
          font-size: $font-14;
        }
      }
    }
  }

  .title {
    font-size: $font-20;
  }
}
</style>
